import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import HomeServicesContent from "../ones/HomeServicesContent";
import HomeAboutSection from "../ones/HomeAboutSection";
import HomeStats from "../ones/HomeStats";

export default function View(props) {
  const [ready, setReady] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    //..

    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <>
        <HomeBanner1 />
        <HomeStats />
        <HomeServicesContent />
        <HomeAboutSection />
        <Footer />
      </>
    );
  } else {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }
}
